import { plannerService } from "../services/planner.service";

const state = {
  loading: false,
  planners: [],
  plannerTasks: [],
};

const getters = {
  isLoading: (state) => state.loading,
  planners: (state) => state.planners,
  plannerTasks: (state) => state.plannerTasks,
};

const actions = {
  async createPlanner({ commit }, plannerObj) {
    commit("setLoading", true);
    try {
      const res = await plannerService.createPlanner(plannerObj);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async getPlanners({ commit }, productVariantID) {
    commit("setLoading", true);
    try {
      const res = await plannerService.getPlanners(productVariantID);
      commit("setPlanners", res?.payload || []);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async getPlannerById({ commit }, plannerId) {
    commit("setLoading", true);
    try {
      const res = await plannerService.getPlannerById(plannerId);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async updatePlanner({ commit }, plannerObj) {
    commit("setLoading", true);
    try {
      const res = await plannerService.updatePlanner(plannerObj);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async deletePlanner({ commit }, plannerId) {
    commit("setLoading", true);
    try {
      const res = await plannerService.deletePlanner(plannerId);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async createPlannerTask({ commit }, plannerTaskObj) {
    commit("setLoading", true);
    try {
      const res = await plannerService.createPlannerTask(plannerTaskObj);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async updatePlannerTask({ commit }, plannerTaskObj) {
    commit("setLoading", true);
    try {
      const res = await plannerService.updatePlannerTask(plannerTaskObj);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async deletePlannerTask({ commit }, plannerTaskId) {
    commit("setLoading", true);
    try {
      const res = await plannerService.deletePlannerTask(plannerTaskId);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async getPlannerTasks({ commit }, plannerId) {
    commit("setLoading", true);
    try {
      const res = await plannerService.getPlannerTasks(plannerId);
      commit("setPlannerTasks", res?.payload || []);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async adaptPlanner({ commit }, adaptPlannerObj) {
    commit("setLoading", true);
    try {
      const res = await plannerService.adaptPlanner(adaptPlannerObj);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async createPlannerTaskAssociations({ commit }, associations) {
    commit("setLoading", true);
    try {
      const res = await plannerService.createPlannerTaskAssociations(associations);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },

  async deletePlannerTaskAssociations({ commit }, { plannerTaskId, associationIds }) {
    commit("setLoading", true);
    try {
      const res = await plannerService.deletePlannerTaskAssociations(plannerTaskId, associationIds);
      commit("setLoading", false);
      return res;
    } catch (error) {
      commit("setLoading", false);
      throw error;
    }
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setPlanners(state, planners) {
    state.planners = planners;
  },
  setPlannerTasks(state, plannerTasks) {
    state.plannerTasks = plannerTasks;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
